<template>
  <a class="outlines-button" :href="link" :title="text" target="target"><!--
  --><span class="outlines-button__text">{{ text }}</span>
  </a>
</template>

<script>
export default {
  name: 'OutlinesButton',
  props: {
    text: { type: String, default: '' },
    link: { type: String, default: '' },
    target: { type: String, default: '_blank' }
  }
}
</script>

<style lang="scss">
$offset: 3px;
.outlines-button {
  display: inline-block;
  position: relative;
  min-width: 143px;
  height: 41px;
  padding: 0 28px;
  color: #1a1a1a;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: color 0.3s ease-in-out;
  cursor: pointer;

  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transition:
      border-color 0.3s ease-in-out,
      transform 0.3s ease-in-out;
  }

  &:before {
    border: 1px solid #e4007f;
    transform: translate(-$offset, -$offset);
  }

  &:after {
    border: 1px solid #1a1a1a;
    transform: translate($offset, $offset);
  }

  &:active{
    color: #e4007f;
    transform: translateY(2px);

    &:before {
      border: 1px solid #1a1a1a;
      transform: translate($offset, $offset);
    }

    &:after {
      border: 1px solid #e4007f;
      transform: translate(-$offset, -$offset);
    }
  }

  &__text {
    display: inline-block;
    width: 100%;
    height: 100%;
    font-size: 1em;
    font-weight: bold;
    line-height: 1.875em;
    text-decoration: none;
    @include use-vertical-align();
  }
}

.desktop {
  .outlines-button {
    &:hover {
      color: #e4007f;

      &:before {
        border: 1px solid #1a1a1a;
        transform: translate($offset, $offset);
      }

      &:after {
        border: 1px solid #e4007f;
        transform: translate(-$offset, -$offset);
      }
    }
  }
}
</style>
